const DISPLAY_NAME_TO_SLUG: Record<string, string> = {
  "mercedes benz": "mercedes-benz",
  mercedes: "mercedes-benz",
  "rolls royce": "rolls-royce",
  "aston martin": "aston-martin",
  "alfa romeo": "alfa-romeo",
  "land rover": "land-rover",
  "range rover": "land-rover",
};

/**
 * Normalizes a previousWorkplace value (display name or slug) to our internal brand slug.
 */
export const workplaceToBrandSlug = (workplace: string): string => {
  const normalized = workplace.trim().toLowerCase();

  if (DISPLAY_NAME_TO_SLUG[normalized]) {
    return DISPLAY_NAME_TO_SLUG[normalized];
  }

  return normalized.replace(/\s+/g, "-");
};
